import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";

import TitledContainer, { StaticText } from "components/TitledContainer";
import Typeahead from "components/Typeahead";

import styles from "forms/forms.css";

const RenderTypeahead = (props) => {
  const {
    errorKey,
    field: { name, value },
    form: { errors, setFieldValue, submitCount },
    isEdit,
    isImportant,
    label,
    onChange,
    onEdit,
    onSelect,
    searchIndex,
    searchKey,
    searchParameters,
  } = props;
  const isEditMode = typeof isEdit === "undefined" ? true : isEdit;

  return (
    <div className={styles.field}>
      <TitledContainer
        isEdit={isEditMode}
        isEmpty={!value}
        onEdit={onEdit}
        title={label}
        isEditable
      >
        {!isEditMode ? (
          <StaticText isImportant={isImportant} text={value} />
        ) : (
          <Typeahead
            isRequired={!!submitCount && !!get(errors, errorKey || name)}
            labelKey={searchKey}
            onInput={onChange || ((newValue) => setFieldValue(name, newValue))}
            onSelect={onSelect || ((newValue) => setFieldValue(name, newValue[searchKey]))}
            searchIndex={searchIndex}
            searchParameters={{ page: 0, hitsPerPage: 20, ...searchParameters }}
            value={value}
          />
        )}
      </TitledContainer>
    </div>
  );
};

RenderTypeahead.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
    submitCount: PropTypes.number,
    errors: PropTypes.object,
  }),
  errorKey: PropTypes.string,
  label: PropTypes.string,
  searchKey: PropTypes.string.isRequired,
  searchIndex: PropTypes.string.isRequired,
  searchParameters: PropTypes.object, // eslint-disable-line
  onSelect: PropTypes.func,
  isEdit: PropTypes.bool,
  onEdit: PropTypes.func,
  onChange: PropTypes.func,
  isImportant: PropTypes.bool,
};

export default RenderTypeahead;
